// extracted by mini-css-extract-plugin
export default {"warning":"ModeMessageWarning-module__warning___O5YYb","icon":"ModeMessageWarning-module__icon___wKtqS"};